import _ from "lodash"
import { useQuery } from "@tanstack/react-query"

import { IUseGetListProps, QueryFnData } from "../../client-query/types"
import { DEFAULT_PAGINATION, DEFAULT_SORT } from "../../client-query/constants"
import { DEFAULT_FILTER_OPTIONS } from "constant"
import { OccupantData } from "providers/venue/types"

import { useGetImdf } from "../useGetImdf"

import { createGetListQueryFn } from "../../client-query/factory"
import { createGetListQueryKey } from "../../client-query/factory/createGetListQueryKey"

type TQueryFnData = QueryFnData<OccupantData>

const DEFAULT_QUERY_KEY = ["occupants"]

export const useGetOccupants = ({
  pagination = DEFAULT_PAGINATION,
  sort = DEFAULT_SORT,
  filter = {},
  filterOptions = DEFAULT_FILTER_OPTIONS,
  queryKey = DEFAULT_QUERY_KEY,
  ...props
}: IUseGetListProps<OccupantData, TQueryFnData, OccupantData[]>) => {
  const { data: imdfData } = useGetImdf()
  const sourceData = _.get(imdfData, "occupants", []) as OccupantData[]

  return useQuery<TQueryFnData, unknown, OccupantData[]>({
    queryKey: createGetListQueryKey(queryKey, {
      filter,
      sort,
    }),
    queryFn: createGetListQueryFn<OccupantData, TQueryFnData>(sourceData, {
      pagination,
      sort,
      filter,
      filterOptions,
    }),
    refetchOnWindowFocus: false,
    // Populated IMDF data has circular refs (unit ↔ section), which causes React Query's
    // structural sharing to infinitely recurse. Disable it to avoid "too much recursion".
    // Trade-off: components get a new reference on every refetch instead of a stable one,
    // but this is fine since refetchOnWindowFocus is off and the queryFn has no network calls.
    structuralSharing: false,
    select: ({ data }) => data,
    gcTime: 1000 * 60 * 5,
    ...props,
  })
}
